import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminManualReferralsApi } from '../services/adminManualReferralsApi';
import { importHistoryKeys } from './useImportHistory';
import type {
  BulkReferralResponseDto,
  BulkReferralUploadPayload,
} from '../types/bulk-referral.type';

/**
 * Commits a bulk upload (`dryRun: false`). Stateless per spec §7.1 — the
 * caller re-sends the same in-memory `File` object it already dry-ran, never
 * prompting the admin to re-select it.
 */
export const useBulkReferralCommit = () => {
  const queryClient = useQueryClient();

  return useMutation<BulkReferralResponseDto, Error, BulkReferralUploadPayload>({
    mutationFn: (payload: BulkReferralUploadPayload) =>
      adminManualReferralsApi.uploadBulkReferrals(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: importHistoryKeys.all });
      // Imported rows show up in the Referrals tab and the engagement metrics.
      queryClient.invalidateQueries({ queryKey: ['analytics'] });
    },
  });
};
